import { LinkedinLogo } from "@phosphor-icons/react";

import {
  MobileSelectionList,
  MobileSelectionListItem,
} from "common/components/MobileSelectionList";
import ProfileImage from "common/components/ui/ProfileImage";
import Skeleton from "common/components/ui/Skeleton";

import type { NavigatorLead } from "../../../types";

interface NavigatorMobileListProps {
  leads: NavigatorLead[];
  isLoading: boolean;
  pageSize: number;
  totalItemCount: number;
}

export default function NavigatorMobileList({
  leads,
  isLoading,
  pageSize,
  totalItemCount,
}: NavigatorMobileListProps) {
  return (
    <MobileSelectionList
      title="Leads"
      data={leads || new Array(pageSize).fill(null)}
      selection={[]}
      totalDataCount={totalItemCount}
    >
      {(lead, listItemProps) => {
        if (isLoading) {
          return (
            <MobileSelectionListItem {...listItemProps}>
              <Skeleton className="size-8 shrink-0 rounded-full" />
              <Skeleton className="h-4 w-28" />
            </MobileSelectionListItem>
          );
        }

        const { picture, full_name, premium, title, company_name } = lead;

        return (
          <MobileSelectionListItem {...listItemProps}>
            <ProfileImage size="sm" src={picture} />

            <div className="flex min-w-0 flex-1 flex-col text-left">
              <div className="flex items-center gap-x-1">
                <span className="truncate text-sm-bold">{full_name}</span>
                {premium && (
                  <LinkedinLogo
                    className="size-4 shrink-0 text-yellow-500"
                    weight="fill"
                  />
                )}
              </div>
              <span className="truncate text-xs-medium text-black-500">
                {[title, company_name].filter(Boolean).join(" · ")}
              </span>
            </div>
          </MobileSelectionListItem>
        );
      }}
    </MobileSelectionList>
  );
}
